export class KendoColumnListDefinition{
    constructor(
        public field: string,
        public template:string = field,
        public attributes:Object = {},
        public format:string = "",
        public title: string = "",
        public headerAttributes: Object = {}){}
}



// WEBPACK FOOTER //
// ./app/insa-models/kendoListGenericColumnDef.ts